<script>

import axios from 'axios';

export default class TodasVisitasRepository {
    
    async getListas(page, token, rawdata) {
        const baseURL = page;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data, { headers: headers });
        return response;
    }

    async getLista(page, token, id) {
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { headers });
        return response;
    }

    async updateLista(page, token, id, rawdata) {
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.put(baseURL, rawdata, { headers });
        return response;
    }
}
</script>
